<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { Table2Icon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .insertTable({ cols: 3, rows: 3, withHeaderRow: false })
    .toggleTableHeaderRow()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="Table2Icon"
    @click="run"
    @keydown.enter="run"
  >
    Table
  </SuggestionListItem>
</template>
